module.exports = __webpack_public_path__ + "media/application/images/svgs/horizontal-arrow-4b21689ada0d71bedc4dc0c748d7532b.svg";